// extracted by mini-css-extract-plugin
export var closeButton = "_is-2";
export var closeButtonIcon = "_is-3";
export var lightboxContent = "_is-1";
export var lightboxOverlay = "_is-0";